<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <b-container>
            <b-row>
                <b-col cols="12" md="5" lg="3">
                    <Sidenav/>
                </b-col>
                <b-col cols="12" md="7" lg="9" v-if="">
                    <TextInfo :content="content"/>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import Breadcrumb from '~/components/Breadcrumb';
import Sidenav from '~/components/Sidenav';
import TextInfo from "@/components/TextInfo";
export default{
    head() {
        return {
            title: this.title,
        }
    },
    data(){
        return{

        }
    },
    computed: {
        breadcrumb() {
            let breadcrumb = [
                {
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Central de atendimento',
                    link: null
                },
                {
                    name: this.title,
                    link: null
                }
            ];
            return breadcrumb;
        },
    },
    components:{
        TextInfo,
        Breadcrumb,
        Sidenav
    },
    async asyncData({params, res, $axios, req, app, error}) {
        try {
            const content = await $axios.$get(`api/v1/cms/?page_id=3`);
            return {
                content: content.data,
                title: content.data.name
            }
        } catch (e) {
            console.error(e)
            // return error({statusCode: 404, message: e.message})
        }
    }

}
</script>
